<template>
  <Component
    v-if="provider"
    :to="to"
    :is="getComponent"
    class="jps-provider-span"
    :nolink="nolink || !provider"
  >
    <slot :org="provider">{{ ls(provider?.name) }}</slot>
  </Component>
</template>

<script lang="ts" setup>
import BaseLink from '~/components/base/BaseLink.vue'

interface Props {
  id?: string
  tag?: string
  href?: string
  nolink?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  tag: 'span',
  nolink: true,
})

const dataStore = useDataStore()
const provider = computed(() => {
  if (!props.id) return null
  return dataStore.provider(props.id)
})
const { ls } = useI18n()

const to = computed(() => {
  if (props.tag !== 'BaseLink') {
    return null
  }
  if (props.href) return props.href
  if (provider.value) {
    if (provider.value.type === 'TEMPORARY') {
      return null
    } else {
      return `/organization/${provider.value.id}`
    }
  }
  return null
})

const getComponent = computed<string | Component>(() => {
  if (props.tag === 'BaseLink') {
    return BaseLink
  } else {
    return props.tag
  }
})
</script>
